// extracted by mini-css-extract-plugin
export default {"uniTargetTable":"index_uniTargetTable__-Tlwb"};